import React, { useReducer } from 'react';
import proptypes from 'prop-types';
const { node } = proptypes;
import { ComboboxContext, defaultContent } from './ComboboxContext';
import { comboboxMotionReducer } from './ComboboxMotionReducer';

const ComboboxProvider = ({ children = null }) => {
  const [comboboxMotionState, comboboxMotionDispatch] = useReducer(
    comboboxMotionReducer,
    undefined,
    defaultContent);

  return (
    <ComboboxContext.Provider value={{ comboboxMotionState, comboboxMotionDispatch }}>
      {children}
    </ComboboxContext.Provider>
  );
};

ComboboxProvider.propTypes = {
  children: node
};

ComboboxProvider.displayName = 'ComboBoxProvider';

export { ComboboxProvider };
